import React from "react";
import Container from "../General/Container/Container";
import LiquidChart from "../Charts/LiquidChart"

const MinifiedResultLoading = ({ percent }) => {
    const liquidStyle = ({ percent: percentVal }) => {
        let fill = "#00C18D"
        let stroke = "#ECFDF5"
        if (percentVal <= .25) {
            fill = "#E54D42"
            stroke = "#FEF2F2"
        } else if (percentVal > .25 && percentVal <= .5) {
            fill = "#FCA522"
            stroke = "#FFF7ED"
        } else if (percentVal > .5 && percentVal <= .75) {
            fill = "#14B2E2"
            stroke = "#EFF6FF"
        }
        return { fill, stroke }
    }

    const getLoadingText = () => {
        if (percent <= .03) {
            return "Initializing."
        }
        if (percent <= .2) {
            return "Searching for audiences."
        }
        if (percent <= .5) {
            return "Summarizing found audiences."
        }
        if (percent <= .75) {
            return "Generating audience explanation."
        }
        if (percent <= .9) {
            return "Generating audience package recommendations."
        }
        return "Finalizing results."
    }

    return <Container className="minified-result-item-loading dcol align-center fullscreen">
        <LiquidChart
            className="d-flex align-items-end justify-content-center"
            style={{
                height: "60%"
            }}
            chartProps={{
                radius: 1,
                liquidStyle
            }}
            percent={percent}
        />
        <span className="minified-result-item-loading-title">{getLoadingText()}</span>
        <span className="minified-result-item-loading-subtitle">We're setting up the necessary data for you..</span>
    </Container>
}

export default MinifiedResultLoading